import { useTranslation } from 'react-i18next';
import { type LabelsModuleSpecsFragment } from '../../../../../api/fragments/LabelsModuleSpecs';
import {
    CreateLabelsModuleDocument,
    type CreateLabelsModuleMutation,
    type CreateLabelsModuleMutationVariables,
} from '../../../../../api/mutations/createLabelsModule';
import { type LabelsModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import LabelsModulePage, { type LabelsModuleProps } from '../../LabelsModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<LabelsModuleSpecsFragment, LabelsModuleSettings> = {
    PageComponent: ({ module }: LabelsModuleProps) => <LabelsModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.LabelsModule.className'),
    getValidator: () => validators.requiredNonEmptyString('displayName'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateLabelsModuleMutation, CreateLabelsModuleMutationVariables>({
                mutation: CreateLabelsModuleDocument,
                variables: {
                    companyId,
                    settings: values,
                },
            })
            .then(({ data }) => data.module),
};

export default implementation;
